angular.module('jv.candidate.details.filters',[])
    // ensure max number of characters are displayed and we don't truncate unnecessarily
    .filter('truncateFullName',function(){
        return function(candidate){
            var maxChars = 40;
            if (!candidate) {
                return;
            }
            var firstName = candidate.firstName;
            var lastName = candidate.lastName;
            var maxFirstNameChars = Math.max(maxChars / 2, maxChars - Math.min(maxChars, lastName.length));
            var maxLastNameChars = Math.max(maxChars / 2, maxChars - Math.min(maxChars, firstName.length));
            if (firstName.length > maxFirstNameChars) {
                firstName = firstName.substr(0, maxFirstNameChars) + '...';
            }
            if (lastName.length > maxLastNameChars) {
                lastName = lastName.substr(0, maxLastNameChars) + '...';
            }
            return firstName + ' ' + lastName;
        };
    });